import { MenuItem, Select, styled } from "@mui/material";

export const ClusterMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingRight: 0,
  paddingLeft: 0,
  alignItems: "center",
  gap: theme.spacing(0.625),
  alignSelf: "stretch",
  borderBottom: `1px solid ${theme.palette.grey?.[600]}`,
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(2.625),
  letterSpacing: "0.5px",
  fontWeight: 500,
  "&:first-child": {
    paddingTop: 0
  },
  "&.Mui-selected": {
    color: theme.palette.primary?.main,
    background: "none!important",
    fontWeight: 700,
    "&:hover": {
      // background: theme.customColors.backgroundSecondaryHover //TODO ripristinare
      background: `rgba(${theme.customColors.backgroundSecondaryHover})` 
    }
  },
  "&:hover": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})` 
    // background: theme.customColors.backgroundSecondaryHover //TODO ripristinare
  }
}));

export const ClusterSelect = styled(Select)(({ theme }) => ({
  borderColor: theme.palette.common?.white,
  //background: theme.linearGradients.gradientB,
  "&.MuiInputBase-root": {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5625),
    paddingBottom: theme.spacing(1.5625),
    fontSize: theme.spacing(1.5),
    fontWeight: 500,
    // lineHeight: theme.spacing(2.625),
    // letterSpacing: "0.5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: theme.spacing(1),
    borderColor: theme.palette.common?.white,
    flexGrow: 1,
    height: theme.spacing(4.375)
  },
  "&.Mui-focused" : {
    borderColor: theme.palette.common?.white
  },
  ".MuiSelect-select": {
    padding: 0,
    display: "flex",
    alignItems: "center"
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.common?.white,
    borderWidth: theme.spacing(0.25),
    borderStyle: "solid"
  },
  ".MuiSelect-iconOpen": {
    transform: "rotate(180deg)"
  },
  ".MuiSelect-icon": {
    transition:"all .3s linear"
  },
  ".MuiMenu-list": {
    marginTop: theme.spacing(1)
  }
}));
